<ng-container>
  <div class="modal-header">
    <h5 class="modal-title" id="endorsementLocationsModelLabel">Document Upload</h5>
  </div>
  <div class="modal-body scroll-modal-body">
    @switch ((documentUploadResult$ | async)) {
      @case ('failure') {
        <div>Sorry, something went wrong. Please try saving again.</div>
      }
      @default {
        <div>Document and endorsements are being added to your order.</div>
      }
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn-secondary" (click)="closeModal()">Close</button>
  </div>
</ng-container>
